import { timestampDTOSchema } from '@tempo-io/common-dto';
import { z } from 'zod';

export const trialDTOSchema = z.object({
  id: z.number(),
  organizationId: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  ...timestampDTOSchema.shape,
});

export const trialPageDTOSchema = z.object({
  data: z.array(trialDTOSchema),
  total: z.number(),
});
